import React, { useEffect } from 'react';

import { Link } from 'react-router-dom';

import LearnLayout from '../../components/learn/LearnLayout';

import GuideCard from '../../components/learn/GuideCard';

import PartnerTip from '../../components/learn/PartnerTip';

import { usePageMeta } from '../../hooks/usePageMeta';
import { hasSsrMeta } from '../../utils/ssrBootstrap';
import { useSsrLearnRoute } from '../../hooks/useSsrLearnRoute';

import {

  articles,

  getArticlesByCategory,

  getLearnManifest,

  regions,

} from '../../content/learn/registry';



const HUB_FAQ = [

  {

    question: 'Can scammers spoof caller ID?',

    answer:

      'Yes. The number on your screen is not proof of who is calling. Hang up and verify using official contact details.',

  },

  {

    question: 'How do I trace an unknown number in Australia?',

    answer:

      'Record the number and time, search it on WhoDatNumber for community reports, and report scams to Scamwatch if needed.',

  },

  {

    question: 'Should I share a one-time code with a caller?',

    answer:

      'Never. Banks and legitimate services will not ask you to read SMS authentication codes aloud.',

  },

  {

    question: 'What if I already sent money?',

    answer:

      'Contact your bank immediately using the number on your card, document what happened, and report to your national fraud authority.',

  },

];



function LearnHub() {
  const manifest = getLearnManifest();
  useSsrLearnRoute('/learn');

  usePageMeta({

    title: manifest.hub.title,

    description: manifest.hub.description,

    canonicalPath: manifest.hub.path,

  });



  useEffect(() => {
    if (hasSsrMeta()) return undefined;

    const script = document.createElement('script');

    script.type = 'application/ld+json';

    script.id = 'learn-hub-faq-ld';

    script.text = JSON.stringify({

      '@context': 'https://schema.org',

      '@type': 'FAQPage',

      mainEntity: HUB_FAQ.map((item) => ({

        '@type': 'Question',

        name: item.question,

        acceptedAnswer: {

          '@type': 'Answer',

          text: item.answer,

        },

      })),

    });

    document.head.appendChild(script);

    return () => {

      const el = document.getElementById('learn-hub-faq-ld');

      if (el?.parentNode) el.parentNode.removeChild(el);

    };

  }, []);



  const scamArticles = getArticlesByCategory('scams');

  const guideArticles = getArticlesByCategory('guides');

  const digitalArticles = getArticlesByCategory('digital');



  return (

    <LearnLayout

      title="Identify unknown callers & avoid scams"

      description="Expert guides and articles — similar to leading AU phone lookup resources, free on WhoDatNumber."

    >

      <p className="text-gray-700 mb-8">

        Uncover unknown numbers with our lookup and community reports. These guides explain caller ID,

        tracing numbers, blocking unwanted calls, and protecting yourself from scams in Australia and beyond.

      </p>



      <section className="mb-10">

        <h2 className="text-2xl font-bold text-gray-900 mb-2">Expert guides & articles</h2>

        <p className="text-gray-600 mb-6">

          {articles.length} guides — overviews, step-by-step tutorials, comparisons, and practical tips.

        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          {guideArticles.map((article) => (

            <GuideCard key={article.slug} article={article} />

          ))}

        </div>

      </section>



      <section className="mb-10">

        <h2 className="text-xl font-bold text-gray-900 mb-4">Scam awareness</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          {scamArticles.map((article) => (

            <GuideCard key={article.slug} article={article} />

          ))}

        </div>

      </section>



      <section className="mb-10">

        <h2 className="text-xl font-bold text-gray-900 mb-4">Protect your accounts</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          {digitalArticles.map((article) => (

            <GuideCard key={article.slug} article={article} />

          ))}

        </div>

        <PartnerTip variant="compact" />

      </section>



      <section>

        <h2 className="text-xl font-bold text-gray-900 mb-4">Report by country</h2>

        <p className="text-gray-600 mb-4">

          Official agencies where you can report scams and get local guidance.

        </p>

        <ul className="flex flex-wrap gap-3">

          {regions.map((r) => (

            <li key={r.code}>

              <Link

                to={`/learn/regions/${r.code}`}

                className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg hover:border-blue-300 text-sm font-medium"

              >

                <span aria-hidden>{r.flag}</span>

                {r.name}

              </Link>

            </li>

          ))}

          <li>

            <Link

              to="/learn/regions"

              className="inline-flex items-center px-4 py-2 text-sm font-medium text-blue-600 hover:underline"

            >

              View all →

            </Link>

          </li>

        </ul>

      </section>

    </LearnLayout>

  );

}



export default LearnHub;



